<template>
  <div id="login">
    <div class="grid-container">
      <div class="Left is-vertical-center">

        <div class="login-form">
          <figure class="image logo" style="margin-bottom:30px">
            <img class="" src="/assets/logo_dark.png" >
          </figure>
          <div class="content">
            <h1 class="title has-text-light">Bei Ihrem Konto anmelden</h1>
            <p class="help" style="margin-top:-15px">
              <span class="has-text-light">oder ein </span>
              <span> <a href="/signup" class="has-text-danger">neues Konto erstellen</a>.</span>
            </p>
          </div>
          <form v-on:submit.prevent style="margin-bottom:13px">
            <div class="field">
              <label class="label has-text-light">Benutzerdaten</label>
            </div>
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <input class="input" type="email" placeholder="E-Mail" v-model="email">
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
                <span class="icon is-small is-right">
                  <i class="fas fa-check"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control has-icons-left">
                <input class="input" type="password" placeholder="Passwort" v-model="password">
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </p>
            </div>
            <div class="field" style="margin-top: 30px;">
              <div class="control">
                <div class="columns">
                  <div class="column">
                    <button
                    type="submit"
                    class="button is-danger is-fullwidth"
                    :class="{'is-loading' : loggingIn}"
                    @click="loginUser">
                      <strong>Login</strong>
                    </button>
                  </div>
                  <div class="column">
                    <a
                    class="button is-danger is-outlined is-fullwidth"
                    :class="{'is-loading' : loggingIn}"
                    href="/signup"
                    >
                      <strong>Neues Konto</strong>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="Right plants">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        email: '',
        password: '',
      }
    },
    computed: {
      loggingIn () {
        return this.$store.getters['authentication/loggingIn']
      }
    },
    methods: {
      loginUser: function () {
        const { email, password } = this;
        if (this.validateInput()) {
          this.$store.dispatch('authentication/AUTH_REQUEST', {email, password})
        } else {
          this.$store.dispatch('alert/ALERT_ERROR', 'Email oder Passwort nicht angegeben !');
        }
      },
      validateInput: function() {
        const { email, password } = this;
        return email.length > 0 && password.length > 0
          ? true
          : false;
      }
    },
    mounted: function () {
      this.$store.dispatch('authentication/AUTH_LOGOUT')
    }
  }
</script>

<style scoped>

  .signup-link {
    color: seagreen
  }

  .signup-link:hover {
    color: darkgreen
  }

  .is-vertical-center {
    display:flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2% 12%;
  }

  .login-form {
    width: 100%;
    max-width: 400px;
  }

  .plants {
    background:url('https://images.unsplash.com/photo-1646038572829-c724d3bad7b7?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
  }

  /* Softens the join between the photo and the dark form panel */
  .plants::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(20, 30, 36, 0.55) 0%, rgba(20, 30, 36, 0) 45%);
  }

  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: "Left Right";
    min-height:100vh;
  }
  .Left {
    grid-area: Left;
    background: linear-gradient(165deg, #24363F 0%, #16232A 100%);
  }
  .Right { grid-area: Right; }

  .logo img {
    max-width: 190px;
  }

  /* Inputs sit on a dark panel here, so give them a matching surface */
  .login-form >>> .input {
    background-color: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.14);
    color: #fff;
  }

  .login-form >>> .input::placeholder {
    color: rgba(255, 255, 255, 0.38);
  }

  .login-form >>> .input:hover {
    border-color: rgba(255, 255, 255, 0.26);
  }

  .login-form >>> .input:focus {
    background-color: rgba(255, 255, 255, 0.08);
    border-color: var(--ois-accent, #FF0266);
  }

  .login-form >>> .control .icon {
    color: rgba(255, 255, 255, 0.38) !important;
  }

  .login-form >>> .button.is-outlined.is-danger {
    border-color: rgba(255, 255, 255, 0.22);
    color: rgba(255, 255, 255, 0.85);
  }

  .login-form >>> .button.is-outlined.is-danger:hover {
    background-color: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.4);
    color: #fff;
  }

  @media screen and (max-width: 900px) {
    .grid-container {
      grid-template-columns: 1fr;
      grid-template-areas: "Left";
    }
    .Right { display: none; }
    .is-vertical-center { padding: 12% 8%; }
  }

</style>
